export default "__VITE_ASSET__Cc2U34H0__"